import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yun",
  "use": "icon-yun-usage",
  "viewBox": "0 0 1582 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1582 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yun\"><path d=\"M1375.488 495.616c118.621 27.462 207.057 133.772 207.057 260.748 0 147.805-119.83 267.636-267.636 267.636H267.636C119.831 1024 0 904.169 0 756.364 0 628.34 89.88 521.309 209.99 494.94a301.52 301.52 0 0 1-.535-17.85c0-160.675 130.234-290.91 290.909-290.91 65.256 0 125.486 21.482 174.01 57.764C726.69 101.562 863.488 0 1024 0c205.661 0 372.364 166.703 372.364 372.364 0 43.194-7.355 84.666-20.876 123.252z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol